module.exports = __webpack_public_path__ + "static/spiritune-logo-8cb3f67a70a173eca946be3bb7dd662c.png";